module.exports = __webpack_public_path__ + "static/media/img_section03_9.9da09060.png";